import uuidv4 from 'uuid/v4';
import settings from '../config/settings';
import axios from './axios';

const { apiBaseURL } = settings;

export default class AssessmentApi {
  static postAssessment(assessment) {
    return axios.post(`${apiBaseURL}/assessments`, assessment);
  }

  static putAssessment(assessment, complete) {
    return axios.put(`${apiBaseURL}/assessments/${assessment.id}${complete ? '?completed=true' : ''}`, assessment);
  }

  static splitPutAssessment(assessment) {
    const payload = {
      ...assessment,
      split: true,
    };
    return axios.put(`${apiBaseURL}/assessments/${assessment.id}`, payload);
  }

  static forcePutAssessment(assessment) {
    const payload = {
      ...assessment,
      forceUpdate: true,
    };
    return axios.put(`${apiBaseURL}/assessments/${assessment.id}`, payload);
  }

  // Uploading print assessments is handled differently from other POST/PUTs
  static uploadAssessment(assessment, onProgress) {
    console.log(assessment.file);
    return axios.post(`${apiBaseURL}/upload-assessment`, assessment, {
      onUploadProgress: (progressEvent) => {
        const percentage = progressEvent.loaded * 100.0 / progressEvent.total;
        onProgress(percentage);
      },
    });
  }

  static downloadAssessment(assessmentId) {
    return axios.post(`${apiBaseURL}/assessments/download/${assessmentId}`,
      { assessmentId },
      { responseType: 'blob' });
  }

  static downloadComparison(assessmentIds) {
    return axios.post(`${apiBaseURL}/download-comparison`,
      { assessmentIds, jwt: sessionStorage.jwt },
      { responseType: 'blob' });
  }

  static getAssessments() {
    return axios.get(`${apiBaseURL}/assessments`);
  }

  static getAssessment(id) {
    return axios.get(`${apiBaseURL}/assessments/${id}`);
  }

  static getSignedUrl(assessment, callback, onFail) {
    const params = {
      objectName: assessment.name,
      contentType: assessment.type,
      uuid: uuidv4(),
      section: assessment.section,
      date: assessment.date,
    };

    axios.post(`${apiBaseURL}/upload-assessment`, params)
      .then((data) => {
        callback(data);
      })
      .catch((error) => {
        console.log(error);
        onFail(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/AssessmentApi.js